/**
 * 'DatadogService' is used to separate Datadog RUM metrics for analysis by domain.
 */
export enum DatadogService {
    AI = 'AI',
    AMAZON_ADVERTISING = 'AMAZON_ADVERTISING',
    AUTH = 'AUTH',
    AUTOMATION = 'AUTOMATION',
    CATEGORY_PERFORMANCE = 'CATEGORY_PERFORMANCE',
    DASHBOARDS = 'DASHBOARDS',
    DISTRIBUTION_ANALYSIS = 'DISTRIBUTION_ANALYSIS',
    HOMEPAGE = 'HOMEPAGE',
    KEYWORD_RESEARCH = 'KEYWORD_RESEARCH',
    MARKET_ANALYSIS = 'MARKET_ANALYSIS',
    PRODUCT_CATALOG = 'PRODUCT_CATALOG',
    SEGMENTS = 'SEGMENTS',
    SHARE_OF_VOICE = 'SHARE_OF_VOICE',
    SYSTEM = 'SYSTEM',
}

export enum DatadogActionName {
    AI_WORKFLOW_COMPLETED = 'ai-workflow-completed',
    AI_WORKFLOW_ERROR = 'ai-workflow-error',
    AI_WORKFLOW_REPORT_SHARED = 'ai-workflow-report-shared',
    AI_WORKFLOW_SUBMITTED = 'ai-workflow-submitted',
    LOAD_WIDGET = 'load-widget',
    LOAD_TABLE = 'load-table',
    LOAD_TYPEAHEAD = 'load-typeahead',
    LOAD_EXECUTIVE_HOME_PAGE = 'load-executive-home-page',
    LOAD_AI_WORKFLOW_CATEGORY_ELIGIBILITY = 'load-ai-workflow-category-eligibility',
    LOAD_CATEGORY_SELECTOR_INITIAL_OPEN = 'load-category-selector-initial-open',
    LOAD_CATEGORY_SELECTOR_EXPAND = 'load-category-selector-expand',
}
